import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Header } from './Header';
import { ScrollToTop } from './ScrollToTop';

const Shell = styled.div`
  /* #root is a centered flex column (align-items: center), so this wrapper must
     claim the full width or it shrinks to its content and leaves side gutters. */
  width: 100%;
`;

const MainContent = styled.main`
  width: 100%;

  /* Remove focus outline - this element receives programmatic focus for accessibility */
  &:focus {
    outline: none;
  }
`;

const PAGE_TITLES: Record<string, string> = {
  '/': 'Welcome',
};

const Layout = () => {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  // WCAG 2.4.2: Update page title on navigation
  useEffect(() => {
    const pageTitle = PAGE_TITLES[pathname] || 'Registration';
    document.title = `${pageTitle} - Happy Hearts`;
  }, [pathname]);

  return (
    <ScrollToTop>
      <Shell>
        <Header showLogo />
        <MainContent id="main-content" ref={mainRef} tabIndex={-1} aria-label="Main content">
          <Outlet />
        </MainContent>
      </Shell>
    </ScrollToTop>
  );
};

export { Layout };
